/*
 * Extracted from sections/footer.liquid's inline <script> (defer_footer_section branch) - a
 * static IIFE with no dynamic Liquid values, ported to a standalone asset so it's HTTP-cacheable
 * across navigations and removed from the inline HTML parse cost, matching the pattern already
 * used for assets/header-nav.js.
 *
 * Loads the real footer-desktop section's HTML on demand (intersection, first interaction, or a
 * 12s fallback) instead of rendering it inline, then executes any <script> tags in the fetched
 * markup (assigning innerHTML never executes embedded scripts, so they're rebuilt manually here).
 */
(() => {
  if (window.__shoplcDeferredFooterLoaderReady) return;
  window.__shoplcDeferredFooterLoaderReady = true;

  const pending = new Set();
  let loadStarted = false;

  function executeInsertedScripts(container) {
    container.querySelectorAll('script').forEach((oldScript) => {
      const script = document.createElement('script');

      for (const attr of oldScript.attributes) {
        script.setAttribute(attr.name, attr.value);
      }

      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  }

  async function loadSection(root) {
    if (!root || root.dataset.deferredFooterLoaded === 'true') return;

    const sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    root.dataset.deferredFooterLoaded = 'true';

    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) throw new Error('Deferred footer section request failed');

      const html = await response.text();
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html.trim();
      executeInsertedScripts(wrapper);
      root.replaceWith(...wrapper.childNodes);
    } catch (error) {
      root.dataset.deferredFooterLoaded = 'false';
      console.warn('[footer] Deferred footer failed:', error);
    }
  }

  function loadAll() {
    if (loadStarted) return;
    loadStarted = true;

    pending.forEach((root) => loadSection(root));
    pending.clear();
  }

  document.querySelectorAll('[data-deferred-footer-section]').forEach((root) => {
    pending.add(root);
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        observer.disconnect();
        loadAll();
      });
    }, { rootMargin: '1200px 0px' });

    pending.forEach((root) => observer.observe(root));
  }

  window.addEventListener('scroll', loadAll, { once: true, passive: true });
  window.addEventListener('pointerdown', loadAll, { once: true, passive: true });
  window.addEventListener('touchstart', loadAll, { once: true, passive: true });
  window.addEventListener('keydown', loadAll, { once: true });
  window.setTimeout(loadAll, 12000);
})();
